import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Panel,
  ButtonSize,
  Typography,
  PrimaryButton,
  ButtonVariant,
  SecondaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './landing-page.css';
import Faq from '../components/faq';
import { APP_TEXT } from '../const/app-text';
import { useAuthContext } from '../auth/auth-provider';
import { PageTracker } from '../components/page-tracker';
import { PageWrapper } from '../components/page-wrapper';
import VideoModal from '../components/modals/video-modal';

const pageText = APP_TEXT.pages.landingPage;

const LandingPage = () => {
  const navigate = useNavigate();
  const { userId } = useAuthContext();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const handleVideoModalClose = () => {
    setIsVideoModalOpen(false);
  };

  return (
    <PageWrapper title={pageText.metaData.title}>
      <PageTracker
        pageName="LandingPage"
        userId={userId}
      />
      <div className="mainWrapper">
        <img
          className="mainImage"
          src="/assets/landing-page-hero-image.png"
          alt="person working at a desk"
        />
        <div className="mainHero">
          <Typography
            variant="h1.bold"
            className="mainHeroTitle"
          >
            {pageText.title}
          </Typography>
          <Typography
            variant="h3.bold"
            className="mainHeroSubTitle"
          >
            {pageText.subtitle}
          </Typography>
          <Typography
            variant="body"
            className="mainHeroBody"
          >
            {pageText.body1}
          </Typography>
          <Typography
            variant="body"
            className="mainHeroBody"
          >
            {pageText.body2}
          </Typography>
          <Typography
            variant="body"
            className="mainHeroBody"
          >
            {pageText.body3}
          </Typography>
          <Typography
            variant="body"
            className="mainHeroBody"
          >
            {pageText.body4}
          </Typography> 
        </div>
      </div>

      <div className="contentWrapper">
        <div className="cardWrapper">
          {pageText.cards.map((card: any) => (
            <Panel
              key={card.id}
              className="panel"
            >
              <div className="panelContent">
                <Typography variant="h3.bold">{card.title}</Typography>
                <Typography variant="body">{card.description}</Typography>
              </div>
              <PrimaryButton
                className="button"
                aria-label={card.buttonTitle}
                buttonSize={ButtonSize.Large}
                onClick={() => navigate(card.url())}
              >
                {card.buttonTitle}
              </PrimaryButton>
            </Panel>
          ))}
        </div>
      </div>

      <div className="explainationWrapper">
        <Typography
          variant="h1.bold"
          className="explainationTitle"
        >
          {pageText.explaination.title}
        </Typography>

        <div className="explainationCardsWrapper">
          {pageText.explaination.cards.map((card: any) => (
            <Panel
              key={card.id}
              className="explainationCard"
            >
              <img
                className="panelImage"
                src={`/assets/${card.imageName}`}
                alt={card.imageAlt}
              />
              <Typography
                variant="h3.bold"
                className="explainationCardText"
              >
                {card.title}
              </Typography>
              <Typography variant="body.small">{card.description}</Typography>
            </Panel>
          ))}
        </div>

        <div className="explainationActionButtons">
          <PrimaryButton
            className="button"
            buttonSize={ButtonSize.Large}
            aria-label={pageText.explaination.actionButtons.buttonOne.title}
            onClick={() => navigate(pageText.cards[0].url())}
          >
            {pageText.explaination.actionButtons.buttonOne.title}
          </PrimaryButton>
          <SecondaryButton
            className="button"
            variant={ButtonVariant.Outline}
            buttonSize={ButtonSize.Large}
            onClick={() => setIsVideoModalOpen(true)}
            iconPos="right"
            icon={
              <FontAwesomeIcon
                icon={pageText.explaination.actionButtons.buttonTwo.startIcon}
                className="p-button-icon fa-regular"
              />
            }
          >
            {pageText.explaination.actionButtons.buttonTwo.title}
          </SecondaryButton>
        </div>
      </div>

      <Faq />

      <VideoModal
        isOpen={isVideoModalOpen}
        onClose={handleVideoModalClose}
        // TODO: Move video to S3 and update the path
        videoSrc="/assets/video/DSI-How-to-video_V10.mp4"
      />
    </PageWrapper>
  );
};

export default LandingPage;
